import React from "react";
import * as MD from "@material-ui/core/";
import { connect } from "react-redux";
import { IApplicationState } from "../../Store";
import { I18N } from "../../Store/I18n/Types";
import { convertColor } from "../../Utils/Various";

const styles = (theme: any) =>
  MD.createStyles({
    formControl: {
      width: "100%",
      marginTop: "5px",
    },
    inputClasses: {
      border: "1px gray",
    },
    label: {
      fontSize: 13,
      fontFamily: "Lato",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: "0px",
      textAlign: "left",
      marginLeft: 17,
      color: theme.palette.text.primary,
    },
  });

interface IPropsFromState {
  i18n: I18N;
}

interface Item {
  id: number;
  name: string;
  color?: string | number;
}

interface IOwnProps {
  title: string;
  listID: number[];
  listStr: string[];
  allListIDs: number[];
  allListStr: string[];
  isAllSelected: boolean;
  list: Item[];
  multiple: boolean;
  updateList?: (id: number, name: string) => void;
  handleAllList?: () => void;
  saveChanges?: (ids: number[], str: string[], bool: boolean) => void;
  open?: boolean;
}

type DrawProps = MD.WithTheme &
  MD.WithStyles<typeof styles> &
  IPropsFromState &
  IOwnProps;

type ISelectState = InitialState;

interface InitialState {}

export class DrawSelectComponent extends React.Component<DrawProps, ISelectState> {
  public constructor(props: DrawProps) {
    super(props);
  }
  private handleAllList(
    ids: number[],
    str: string[],
    isAllitemsSelected: boolean,
    allID: number[],
    allStr: string[]
  ) {
    if (isAllitemsSelected) {
      ids = [];
      str = [""];
    } else {
      ids = allID;
      str = allStr;
    }
    return [ids, str];
  }
  private filterList(ids: number[], str: string[], id: number, name: string) {
    if (ids.includes(id)) {
      ids = ids.filter((e) => e !== id);
      str = str.filter((e) => e !== name);
    } else {
      ids.push(id);
      str.push(name);
    }
    return [ids, str];
  }

  private updateItems(id: number, name: string) {
    let result = this.filterList(
      this.props.listID,
      this.props.listStr,
      id,
      name
    );
    let newIDs = result[0] as number[];
    let newStr = result[1] as string[];
    let newIsAllItemsSelected = false;

    this.props.saveChanges === undefined
      ? this.props.updateList !== undefined && this.props.updateList(id, name)
      : this.props.saveChanges(newIDs, newStr, newIsAllItemsSelected);
  }
  private handleAllItems() {
    let result: any = this.handleAllList(
      this.props.listID,
      this.props.listStr,
      this.props.isAllSelected,
      this.props.allListIDs,
      this.props.allListStr
    );
    this.props.saveChanges === undefined
      ? this.props.handleAllList !== undefined && this.props.handleAllList()
      : this.props.saveChanges(result[0], result[1], !this.props.isAllSelected);
  }

  public render() {
    const { i18n, classes, theme } = this.props;

    return (
      <MD.FormControl
        title={this.props.listStr.filter((e) => e !== "").join(", ")}
        className={this.props.classes.formControl}
        style={{ padding: this.props.multiple ? "5px 10px 5px 10px" : "10px" }}
      >
        <MD.InputLabel
          className={classes.label}
          style={{ marginTop: this.props.multiple ? -14 : -9 }}
          shrink={this.props.multiple ? false : true}
        >
          {this.props.title}
        </MD.InputLabel>
        <MD.Select
          open={this.props.open}
          disabled={
            this.props.open !== undefined && !this.props.open ? true : undefined
          }
          labelId="mutiple-checkbox-label"
          id="mutiple-checkbox"
          multiple={this.props.multiple}
          variant="filled"
          value={
            this.props.isAllSelected
              ? ["All"]
              : this.props.multiple
              ? this.props.listID
              : this.props.listID[0] || ""
          }
          input={
            <MD.OutlinedInput className={this.props.classes.inputClasses} />
          }
          renderValue={(value: any) => {
            if (!this.props.multiple) {
              return (
                <p
                  style={{
                    margin: "0px",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    fontSize: "13px",
                  }}
                >
                  {this.props.isAllSelected && this.props.list.length > 0
                    ? this.props.title === i18n._("Persons")
                      ? i18n._("ALL") + " - " + this.props.list.length
                      : i18n._("ALL")
                    : this.props.listStr.filter((e) => e !== "").join(", ")}
                </p>
              );
            } else return null;
          }}
          MenuProps={{
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: "top",
              horizontal: "left",
            },
          }}
        >
          {this.props.list.length > 0 && (
            <MD.MenuItem
              value={"All"}
              onClick={() => this.handleAllItems()}
              key={"ALL"}
              style={{ padding: "0px", height: "25px" }}
            >
              {this.props.multiple && (
                <MD.Checkbox
                  checked={this.props.isAllSelected}
                  style={{
                    color: this.props.isAllSelected
                      ? theme.palette.primary.main
                      : theme.palette.primary.light,
                  }}
                />
              )}
              <MD.ListItemText
                style={{ paddingLeft: this.props.multiple ? "0px" : "10px" }}
                primary={i18n._("ALL")}
              />
            </MD.MenuItem>
          )}
          {this.props.list !== null &&
            this.props.list.map((x: any, index: any) => (
              <MD.MenuItem
                onClick={() => this.updateItems(x.id, x.name)}
                key={index}
                value={x.id}
                style={{
                  paddingLeft: "0px",
                  height: "25px",
                  backgroundColor:
                    (this.props.listID.indexOf(x.id) > -1 ||
                      this.props.isAllSelected) &&
                    this.props.multiple
                      ? "rgba(0, 0, 0, 0.08)"
                      : "inherit",
                }}
              >
                {this.props.multiple && (
                  <MD.Checkbox
                    icon={
                      x.color !== undefined ? (
                        <span
                          style={{
                            backgroundColor: convertColor(x.color),
                            borderRadius: 3,
                            width: 18,
                            height: 18,
                            margin: 3,
                          }}
                        />
                      ) : undefined
                    }
                    style={{
                      color:
                        x.color !== undefined
                          ? convertColor(x.color)
                          : this.props.listID.indexOf(x.id) > -1 ||
                            this.props.isAllSelected
                          ? theme.palette.primary.main
                          : theme.palette.primary.light,
                    }}
                    checked={
                      this.props.listID.indexOf(x.id) > -1 ||
                      this.props.isAllSelected
                    }
                  />
                )}
                <MD.ListItemText
                  style={{ paddingLeft: this.props.multiple ? "0px" : "10px" }}
                  primary={x.name}
                />
              </MD.MenuItem>
            ))}
        </MD.Select>
      </MD.FormControl>
    );
  }
}
const mapStateToProps = ({ i18n }: IApplicationState) => ({
  i18n: i18n.i18n,
});

export const DrawSelect = connect(
  mapStateToProps,
  null
)(MD.withTheme(MD.withStyles(styles)(DrawSelectComponent)));
